export default __webpack_public_path__ + "static/media/ugurkaan1.75a4dbcd.jpg";